var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[(_vm.post.featured_image)?_c('router-link',{attrs:{"to":{ name: 'post', params: { slug: _vm.post.slug } }}},[_c('img',{attrs:{"src":_vm.post.featured_image,"alt":"Blog Post Featured Image"}})]):_vm._e(),_c('span',[_c('i',[_vm._v("—")]),_vm._v(" "+_vm._s(_vm.getFormattedDate(_vm.post.date))+" "),_c('i',[_vm._v("—")])]),_c('h3',[_c('router-link',{attrs:{"to":{
        name: 'post',
        params: {
          slug: _vm.post.slug
        }
      }},domProps:{"innerHTML":_vm._s(_vm.post.title.rendered)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }